import React, { ReactElement } from 'react';

const Error504 = (): ReactElement => {
  return (
    <div className="error_504_wrap">
      <img src="/assets/images/illust/illust-login-504error.jpg" alt="시스템 점검 중" className="error_504_img" />
    </div>
  );
};

export default Error504;
